const faq = {
    faq: {
      pageTitle: 'FAQ',
      pageDescription: '자주 묻는 질문',
      list: [
        {
          title: 'IOPS SPACE는 어떤 절차로 이루어지나요?',
          description:
            '위성 등록 => 교신 프로필 추가 => 지상국과 위성 설정 => 접속 일정 확인 및 예약 => 결제 요청 메일 수신 => 결제 후 확인 메일 수신 => 위성 데이터 수신'
        },
        {
          title: 'IOPS SPACE는 어떻게 사용하나요?',
          description:
            '홈페이지에서 회원가입 후, 1번 질문의 절차에 따라 진행하시면 됩니다.'
        },
        {
          title: '결제는 어떻게 하나요?',
          description:
            '1. 접속 일정을 예약하면, 결제 계좌가 포함된 이메일이 전송됩니다.\n2. 해당 계좌로 3일 이내에 금액을 송금하셔야 예약이 유지됩니다.\n3. 결제가 완료되면, 최종 예약 확인 메일이 발송되며 예약이 확정됩니다.'
        },
        {
          title: '데이터는 언제 받을 수 있나요?',
          description:
            '위성 데이터 다운로드 링크는 회원가입 시 등록한 이메일로 발송됩니다.\n해당 데이터는 IOPS SPACE 서버에 30일간 보관되며, 이후 자동 삭제됩니다.'
        },
        {
          title: '예약한 일정은 변경할 수 있나요?',
          description:
            '네, 언제든지 변경 가능합니다. (단, 등록일로부터 7일 이후의 일정 변경 시에는 궤도 재계산이 필요합니다.)'
        },
        {
          title: '지원하는 주파수 및 송수신 성능은 어떻게 되나요?',
          description:
            `안테나 사양\n• G/T : S 밴드(≥ 14dB/k), X 밴드(≥ 27 dB/k)\n• 안테나 속도 : AZ: 0.1~20°/s, EL: 0.1~20°/s, Tilt: 0.1~5°/s\n• 포인팅 정확도 : ≤ 0.1°\n• 안테나 지름 : 4.5m\n• 주파수\n - 송신(Tx): 2025 ~ 2120 MHz\n - 수신(Rx): 2200 ~ 2300 MHz`
        },
        {
          title: '어떤 종류의 위성과 접속할 수 있나요?',
          description:
            'IOPS SPACE는 **LEO 큐브위성(CubeSat)**에 최적화되어 있으며, GEO 및 심우주(Deep Space) 위성도 지원합니다. 지상국은 다중 커버리지를 제공합니다.'
        },
        {
          title: '비밀번호를 잊어버렸어요.',
          description:
            '비밀번호 재설정 링크는 가입 시 등록한 이메일로 발송됩니다.'
        }
      ]
    }
  };
  
  export default faq;
  